import styles from "./taskdetails.module.css";
import TaskCheckList from "./TaskCheckList";
import { Calendar, ChevronDown, User, X } from "react-feather";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import DateRangePicker from "rsuite/DateRangePicker";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Dropdown } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from "react";
import { toast } from "react-smart-toaster";
import { TableLoaderSmall } from "../../../components/LoaderC";
import axios from "axios";
import { AddLogCallAPI } from "../../../components/AddLogs";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));

const TaskDetails = ({
  setDetailsTaskModalOpen,
  selectedId,
  setLoading,
  setSnackbarOpen,
  setSnackbarMsg,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const currentWeekStart = dayjs().startOf("week");
  const currentWeekEnd = dayjs().endOf("week");
  const minDate = currentWeekStart.subtract(4, "week");

  const [contentLoading, setContentLoading] = useState(true);
  const [taskDetails, setTaskDetails] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState([
    currentWeekStart.toDate(),
    currentWeekEnd.toDate(),
  ]);
  const [taskCheckList, setTaskCheckList] = useState([]);
  const [archiveTaskModalOpen, setArchiveTaskModalOpen] = useState(false);
  const [isArchive, setIsArchive] = useState(false);

  const disableDate = (date) => {
    const d = dayjs(date);
    return d.isBefore(minDate, "day") || d.isAfter(currentWeekEnd, "day");
  };

  useEffect(() => {
    async function fetchTaskDetails() {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      axios(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          setContentLoading(false);
          setTaskDetails(response.data.data);
        })
        .catch(() => {
          setContentLoading(false);
        });
    }
    if (selectedId) fetchTaskDetails();
  }, [selectedId, getAccessTokenSilently]);

  useEffect(() => {
    async function fetchTaskChecklist(startDate, endDate) {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      axios(
        process.env.REACT_APP_CASE_API_URL +
        "v1/tasks-check-list?task_id=" +
        selectedId +
        "&start=" +
        startDate +
        "&end=" +
        endDate,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => {
          setTaskCheckList(response.data.data);
        })
        .catch(() => { });
    }

    if (selectedWeek) {
      let startDate = dayjs(selectedWeek[0]).format("YYYY-MM-DD");
      let endDate = dayjs(selectedWeek[1]).format("YYYY-MM-DD");

      fetchTaskChecklist(startDate, endDate);
    }
  }, [selectedWeek, selectedId]);

  useEffect(() => { }, [taskCheckList]);

  const statusChangeConfirm = async () => {
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });
    setArchiveTaskModalOpen(false);
    setLoading(true);

    let data = { is_archived: 0 };
    if (isArchive) {
      data = { is_archived: 1 };
    }

    axios
      .put(
        process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setTaskDetails((prev) => ({
          ...prev,
          is_archived: isArchive ? 1 : 0,
        }));

        setSnackbarMsg(response.data.message);
        setSnackbarOpen(true);

        let logData = {
          title: isArchive
            ? "Task list has been disabled"
            : "Task list has been enabled",
          description: [
            "Name: " + response?.data?.data?.title,
            "Property: " + response?.data?.data?.property_name,
            "Technician: " + response?.data?.data?.technician_name,
          ],
        };
        AddLogCallAPI(logData, token);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const onCheckList = async (listId, isChecked) => {
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    let data = { is_checked: isChecked ? 1 : 0 };

    axios
      .put(
        process.env.REACT_APP_CASE_API_URL + "v1/check-list-admin/" + listId,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => { })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const getPlaceholder = () => {
    if (!selectedWeek || !selectedWeek[0] || !selectedWeek[1]) {
      return "Select week";
    }

    const start = dayjs(selectedWeek[0]);
    const end = dayjs(selectedWeek[1]);

    // find current week range
    const thisWeekStart = dayjs().startOf("week");
    const thisWeekEnd = dayjs().endOf("week");

    const isCurrentWeek =
      start.isSame(thisWeekStart, "day") && end.isSame(thisWeekEnd, "day");

    if (isCurrentWeek) {
      return `Current Week (${start.format("MM/DD")} - ${end.format("MM/DD")})`;
    }

    return `${start.format("MM/DD")} - ${end.format("MM/DD")}`;
  };

  return (
    <>
      {contentLoading && (
        <div className="Loader TableLoader">
          <TableLoaderSmall />
        </div>
      )}

      {!contentLoading && (
        <>
          <div className={`${styles.PanelCloasesec}`}>
            <p>{taskDetails?.title}</p>
            <Dropdown
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                className={
                  taskDetails?.is_archived === 1
                    ? `${styles.ReferStatusBU} ${styles.StatusBuRed}`
                    : `${styles.ReferStatusBU} ${styles.StatusBuGreen}`
                }
              >
                {taskDetails?.is_archived === 1 ? "Disable" : "Enable"}{" "}
                <ChevronDown className={`${styles.DownArrowStatus}`} />
              </Dropdown.Toggle>

              <Dropdown.Menu className="DropDownMenuBoxCus">
                {taskDetails?.is_archived === 1 && (
                  <Dropdown.Item
                    className="DropDListWIcon"
                    onClick={(e) => {
                      setArchiveTaskModalOpen(true);

                      setIsArchive(false);
                    }}
                  >
                    Enable
                  </Dropdown.Item>
                )}
                {taskDetails?.is_archived === 0 && (
                  <Dropdown.Item
                    className="DropDListWIcon"
                    onClick={(e) => {
                      setArchiveTaskModalOpen(true);

                      setIsArchive(true);
                    }}
                  >
                    Disable
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
            <div className={`${styles.SMProCardHeadBuSec}`}>
              {taskDetails?.technician_name !== '' && <button className={`${styles.PanelMailBU}`}>
                <BootstrapTooltip
                  title={
                    <div className={`${styles.IncomeLineTooltip}`}>
                      <p>{taskDetails?.technician_name} Assigned</p>
                    </div>
                  }
                >
                  <User />
                </BootstrapTooltip>
              </button>}
              {taskDetails?.days?.length > 0 && <button className={`${styles.PanelMailBU}`}>
                <BootstrapTooltip
                  title={
                    <div className={`${styles.IncomeLineTooltip}`}>
                      {taskDetails?.days?.map((it, ind) => {
                        return (
                          <p key={ind}>
                            #{ind + 1}. {it}
                          </p>
                        );
                      })}
                    </div>
                  }
                >
                  <Calendar />
                </BootstrapTooltip>
              </button>}
            </div>
            <button
              className={`${styles.close}`}
              onClick={(e) => setDetailsTaskModalOpen(false)}
            >
              <X />
            </button>
          </div>
          <div className={`${styles.TaskDetailsBody}`}>
            <div className={`${styles.DetailsMemberSec}`}>
              <p className={`${styles.Title}`}>Description</p>
              <p className={`${styles.Description}`}>
                {taskDetails?.description}
              </p>
            </div>

            <div className={`${styles.SwitchDiv} FormGroup Filter`}>
              <div className={`${styles.DashFilterSec} DashFilterSec`}>
                <DateRangePicker
                  oneTap
                  showOneCalendar
                  hoverRange="week"
                  ranges={[]}
                  format={"MM/dd/yyyy"}
                  placement={"bottomEnd"}
                  caretAs={Calendar}
                  disabledDate={disableDate}
                  cleanable={false}
                  //   defaultValue={selectedWeek}
                  onChange={(e) => {
                    setSelectedWeek(e);
                  }}
                  value={selectedWeek}
                  renderValue={(value) => {
                    if (!value || !value[0] || !value[1]) return "Select week";

                    const start = dayjs(value[0]).format("MM/DD/YYYY");
                    const end = dayjs(value[1]).format("MM/DD/YYYY");

                    const thisWeekStart = dayjs().startOf("week");
                    const thisWeekEnd = dayjs().endOf("week");

                    const isCurrentWeek =
                      dayjs(value[0]).isSame(thisWeekStart, "day") &&
                      dayjs(value[1]).isSame(thisWeekEnd, "day");

                    if (isCurrentWeek) {
                      return `Current Week (${start} ~ ${end})`;
                    }

                    return `${start} ~ ${end}`;
                  }}
                />
              </div>
            </div>
            <div className="FormAccording ProspectTask Theme">
              <TaskCheckList
                taskCheckList={taskCheckList}
                setTaskCheckList={setTaskCheckList}
                onCheckList={onCheckList}
              />
            </div>
          </div>
        </>
      )}

      <Dialog
        open={archiveTaskModalOpen}
        onClose={(e) => setArchiveTaskModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to {isArchive ? "disable" : "enable"} task list?
          <button onClick={(e) => setArchiveTaskModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">
                The task will be {isArchive ? "disabled" : "enabled"}{" "}
                immediately. You can {isArchive ? "enable" : "disable"} it at
                any time.
              </label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={(e) => setArchiveTaskModalOpen(false)}
            className="CancelPopupBU"
          >
            Cancel
          </button>
          <button
            onClick={(e) => statusChangeConfirm(false)}
            className="SubmitPopupBU"
          >
            Submit
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TaskDetails;
